var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (config, css) {
      pug_mixins["link"] = pug_interp = function(item){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (item.href && item.href !== "#") {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", item.href, true, true)+pug.attr("title", item.title, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.text || item.href) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else
if (item.menu) {
pug_html = pug_html + "\u003Cbutton" + (pug.attr("aria-label", item.title, true, true)+pug.attr("data-toggle", item.toggle, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.text) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003Cul" + (pug.attr("id", item.toggle, true, true)) + "\u003E";
// iterate item.menu
;(function(){
  var $$obj = item.menu;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var subitem = $$obj[index];
subitem.toggle = item.toggle + "_" + index
pug_html = pug_html + "\u003Cli\u003E";
pug_mixins["link"](subitem);
pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var subitem = $$obj[index];
subitem.toggle = item.toggle + "_" + index
pug_html = pug_html + "\u003Cli\u003E";
pug_mixins["link"](subitem);
pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
}
else {
pug_html = pug_html + (pug.escape(null == (pug_interp = item.text) ? "" : pug_interp));
}
};
pug_mixins["form"] = pug_interp = function(form){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cform" + (pug.attr("action", form.action, true, true)+pug.attr("method", form.method, true, true)) + "\u003E";
if (form.hidden) {
// iterate form.hidden
;(function(){
  var $$obj = form.hidden;
  if ('number' == typeof $$obj.length) {
      for (var name = 0, $$l = $$obj.length; name < $$l; name++) {
        var value = $$obj[name];
pug_html = pug_html + "\u003Cinput" + (" type=\"hidden\""+pug.attr("name", name, true, true)+pug.attr("value", value, true, true)) + "\u003E";
      }
  } else {
    var $$l = 0;
    for (var name in $$obj) {
      $$l++;
      var value = $$obj[name];
pug_html = pug_html + "\u003Cinput" + (" type=\"hidden\""+pug.attr("name", name, true, true)+pug.attr("value", value, true, true)) + "\u003E";
    }
  }
}).call(this);

}
pug_html = pug_html + "\u003Cinput" + (" type=\"text\""+pug.attr("name", form.name || "search", true, true)+pug.attr("value", form.value || "", true, true)+pug.attr("aria-label", form.text || "Search Site", true, true)+pug.attr("placeholder", form.text || "Search Site", true, true)) + "\u003E\u003Cbutton type=\"submit\"\u003E\u003Cspan" + (pug.attr("aria-label", form.button || "Search", true, true)) + "\u003E\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E";
if (form.menu) {
pug_html = pug_html + "\u003Cul\u003E";
// iterate form.menu
;(function(){
  var $$obj = form.menu;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var item = $$obj[index];
pug_html = pug_html + "\u003Cli\u003E";
pug_mixins["link"](item);
pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var item = $$obj[index];
pug_html = pug_html + "\u003Cli\u003E";
pug_mixins["link"](item);
pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
}
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_html = pug_html + "\u003Cheader" + (pug.attr("class", pug.classes([css.template_header], [true]), false, true)) + "\u003E";
if (config.main && config.main.id && config.main.top) {
pug_html = pug_html + "\u003Ca" + (pug.attr("class", pug.classes([css.template_header_skip], [true]), false, true)+pug.attr("href", "#" + config.main.id, true, true)+pug.attr("id", config.main.top, true, true)) + "\u003ESkip to main content\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([css.template_header_top], [true]), false, true)) + "\u003E\u003Cdiv" + (pug.attr("class", pug.classes([css.template_container], [true]), false, true)) + "\u003E\u003Ca" + (pug.attr("class", pug.classes([css.template_header_top_logo], [true]), false, true)+" href=\"https:\u002F\u002Fwww.bgsu.edu\u002F\"") + "\u003E\u003Csvg xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" viewBox=\"0 0 392.4 110.16\"\u003E\u003Csymbol id=\"bgsu_template_logo\"\u003E\u003Ctitle\u003EBGSU\u003C\u002Ftitle\u003E\u003Cpath d=\"m28.8 44.2 14.69-.14c7.77 0 12.81-3 12.81-11 0-5.9-5-10.08-11.8-10.08H28.8V44.2m16.85 42.48c7.2 0 12.52-4.32 12.52-10.8 0-5.76-4-11.23-10.51-11.66H28.8v22.46ZM0 106.84V2.87h49.82c19.59.15 36 8.93 36 27.22 0 12.81-10.8 20.59-22.46 22.75v.29c13.82 1.87 25 10.66 25 25.49 0 30.24-38.59 28.22-39.6 28.22Z\"\u002F\u003E\u003Cpath d=\"M165.61 68h-21.16V47.8h50v55.58c-23.32 3.46-27.79 5.62-52.84 5.62-32.4-1-52.13-21.6-52.13-54.14S109.17 1.72 141.57.71c25.2-.72 51.69 3 52.12 33.27h-28.8c-1.44-10.08-9.36-13.11-18.89-13.11-19.44 0-26.35 17.14-26.35 34 0 20.44 10.22 34 31 34a77.35 77.35 0 0 0 15-1.73V68\"\u002F\u003E\u003Cpath d=\"M232.85 109c-16.56 0-30.52-12.1-31-29.23H212c.29 16 12.1 20.59 26.07 20.59 11.66 0 25-6.77 25-20 0-10.36-7.48-15.26-16.27-18.14-16.8-5.64-42.46-10.96-42.46-33.43 0-18.14 16.71-28.08 33.12-28.08 13.68 0 31.54 4.76 33.84 24.77h-10.08c-.29-12.81-12-16.13-22.61-16.13s-24.19 5.48-24.19 18.15c0 29.52 58.75 16.12 58.75 52 0 22.61-19.44 29.52-40.32 29.52\"\u002F\u003E\u003Cpath d=\"M293.38 2.87v67.25C294.1 89 304.9 100.36 322 100.36S350 89 350.69 70.12V2.87h9.36v67.39C359.77 92.58 347.24 109 322 109s-37.73-16.42-38-38.74V2.87h9.36\"\u002F\u003E\u003Cpath d=\"M384.25 93.71a8.41 8.41 0 0 1 0 11.84 8.31 8.31 0 0 1-11.81 0 8.41 8.41 0 0 1 0-11.85 8.21 8.21 0 0 1 11.86 0Zm1.25-1.29a9.73 9.73 0 0 0-7.16-3 9.93 9.93 0 0 0-7 2.75 9.65 9.65 0 0 0-3.17 7.38 10.13 10.13 0 1 0 17.29-7.16Zm-5.91 6.39a2.76 2.76 0 0 1-1.61.41h-1.13V96h.71a4.76 4.76 0 0 1 1.7.24 1.28 1.28 0 0 1 .91 1.28 1.51 1.51 0 0 1-.58 1.29Zm-2.74 2.43h.61l.65.05a3.13 3.13 0 0 1 1 .17 1.39 1.39 0 0 1 .83.83 5.18 5.18 0 0 1 .18 1.37 6.77 6.77 0 0 0 .18 1.55h2.8l-.1-.31a1.94 1.94 0 0 1-.07-.33 1.83 1.83 0 0 1 0-.33v-1a3 3 0 0 0-1-2.52 3.8 3.8 0 0 0-1.6-.64 3.77 3.77 0 0 0 1.95-.76 2.5 2.5 0 0 0 .79-2 2.83 2.83 0 0 0-1.5-2.68 5.55 5.55 0 0 0-2.21-.58L377 94h-3.1v11.22h3Z\"\u002F\u003E\u003C\u002Fsymbol\u003E\u003Cuse xlink:href=\"#bgsu_template_logo\"\u002F\u003E\u003C\u002Fsvg\u003E\n\u003C\u002Fa\u003E";
if (config.unit && config.unit.text) {
pug_html = pug_html + "\u003Ca" + (pug.attr("class", pug.classes([css.template_header_top_unit], [true]), false, true)+pug.attr("href", config.unit.href, true, true)) + "\u003E\u003Cdiv\u003E";
if (config.unit.thin) {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = config.unit.thin + " ") ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + (pug.escape(null == (pug_interp = config.unit.text) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (config.site || config.menu || config.user || config.form) {
pug_html = pug_html + "\u003Cnav" + (pug.attr("class", pug.classes([css.template_header_nav], [true]), false, true)+" aria-label=\"Site navigation\"") + "\u003E\u003Cdiv" + (pug.attr("class", pug.classes([css.template_container], [true]), false, true)) + "\u003E";
if (config.site) {
if (config.site.heading) {
pug_html = pug_html + "\u003Ch1" + (pug.attr("class", pug.classes([css.template_header_nav_site], [true]), false, true)) + "\u003E";
pug_mixins["link"](config.site);
pug_html = pug_html + "\u003C\u002Fh1\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([css.template_header_nav_site], [true]), false, true)) + "\u003E";
pug_mixins["link"](config.site);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
}
if (config.menu || config.user || config.form) {
pug_html = pug_html + "\u003Cbutton" + (pug.attr("class", pug.classes([css.template_header_nav_menu_toggle], [true]), false, true)+" aria-label=\"Toggle site navigation\""+pug.attr("data-toggle", css.template_header_nav_menu, true, true)) + "\u003E☰\u003C\u002Fbutton\u003E\u003Cdiv" + (pug.attr("class", pug.classes([css.template_header_nav_menu], [true]), false, true)+pug.attr("id", css.template_header_nav_menu, true, true)) + "\u003E";
if (config.menu) {
pug_html = pug_html + "\u003Cul\u003E";
// iterate config.menu
;(function(){
  var $$obj = config.menu;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var item = $$obj[index];
item.toggle = css.template_header_nav_menu
item.toggle += "_" + index
pug_html = pug_html + "\u003Cli" + (pug.attr("class", pug.classes([item.class], [true]), false, true)) + "\u003E";
pug_mixins["link"](item);
pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var item = $$obj[index];
item.toggle = css.template_header_nav_menu
item.toggle += "_" + index
pug_html = pug_html + "\u003Cli" + (pug.attr("class", pug.classes([item.class], [true]), false, true)) + "\u003E";
pug_mixins["link"](item);
pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
}
if (config.user) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([css.template_header_nav_menu_user], [true]), false, true)) + "\u003E";
if (config.user.text) {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = config.user.text) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
if (config.user.menu) {
pug_html = pug_html + "\u003Cul\u003E";
// iterate config.user.menu
;(function(){
  var $$obj = config.user.menu;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var item = $$obj[index];
pug_html = pug_html + "\u003Cli\u003E";
pug_mixins["link"](item);
pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var item = $$obj[index];
pug_html = pug_html + "\u003Cli\u003E";
pug_mixins["link"](item);
pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
if (config.form) {
pug_mixins["form"](config.form);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E";
}
if (config.note && config.note.header) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([css.template_note], [true]), false, true)) + "\u003E\u003Cdiv" + (pug.attr("class", pug.classes([css.template_container], [true]), false, true)) + "\u003E" + (null == (pug_interp = config.note.header) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fheader\u003E";
    }.call(this, "config" in locals_for_with ?
        locals_for_with.config :
        typeof config !== 'undefined' ? config : undefined, "css" in locals_for_with ?
        locals_for_with.css :
        typeof css !== 'undefined' ? css : undefined));
    ;;return pug_html;};
module.exports = template;